/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character inspector`)
};

const es_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de caracteres`)
};

const de_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen-Inspektor`)
};

const nl_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakterinspecteur`)
};

const fr_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur de caractères`)
};

const it_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore di caratteri`)
};

const pt_br2_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de caracteres`)
};

const pt_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de caracteres`)
};

const ja_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「文字インスペクタ」`)
};

const zh_home_seo_ci_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符检查器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_ci_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_ci_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_ci_title", locale)
	if (locale === "en") return en_home_seo_ci_title(inputs)
	if (locale === "es") return es_home_seo_ci_title(inputs)
	if (locale === "de") return de_home_seo_ci_title(inputs)
	if (locale === "nl") return nl_home_seo_ci_title(inputs)
	if (locale === "fr") return fr_home_seo_ci_title(inputs)
	if (locale === "it") return it_home_seo_ci_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_ci_title(inputs)
	if (locale === "pt") return pt_home_seo_ci_title(inputs)
	if (locale === "ja") return ja_home_seo_ci_title(inputs)
	return zh_home_seo_ci_title(inputs)
};